import React from 'react';
import { FCWW } from '../../../../types.ts';
import { SelectFieldOption } from '@/eventConfig/types.ts';

interface OptionGroupProps {
  selectOption: SelectFieldOption;
}

export const OptionGroup: FCWW<OptionGroupProps> = ({ selectOption, children }) => {
  const { label, value } = selectOption;
  return <optgroup label={value ? value : label.en}>{children}</optgroup>;
};
